import { render } from "./smsTemplate.vue?vue&type=template&id=679df4f0&scoped=true"
import script from "./smsTemplate.vue?vue&type=script&lang=js"
export * from "./smsTemplate.vue?vue&type=script&lang=js"

import "./smsTemplate.vue?vue&type=style&index=0&id=679df4f0&lang=scss&scoped=true"
import "./smsTemplate.vue?vue&type=style&index=1&id=679df4f0&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679df4f0"]])

export default __exports__